import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import ToastMessages from '../../components/ToastMessages/toastMessages';
import { api } from '../../services/api';
import { populateReprocessing } from '../../store/ducks/tables/actions';
import { Deliveries } from '../../store/ducks/freight/types';
import { CartStatus } from '../../types/drawer.types';

export interface GetDeliveriesResponse {
  page: number;
  rows: Deliveries[];
  totalRecords: number;
}

export default function useGetDeliveries() {
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();

  async function execute(params: {
    page?: number;
    rowsPerPage?: number;
    status?: string;
    cartStatus?: CartStatus;
    freightId?: string;
  }): Promise<GetDeliveriesResponse | undefined> {
    setLoading(true);
    try {
      const response = await api.get('v1/backoffice/deliveries', {
        params: {
          page: params.page || 1,
          rowsPerPage: params.rowsPerPage || 20,
          cartStatus: params.cartStatus,
          freightId: params.freightId,
          status: params.status === 'Todos' ? null : params.status,
        },
      });

      if (response.status === 200 && !status) {
        dispatch(populateReprocessing(response.data));
        return response.data;
      }
    } catch (error) {
      if (!Array.isArray((error as any).response.data.message)) {
        toast.error(ToastMessages.general.error.operationFailed);
      } else {
        (error as any).response.data.message.map((err: any) =>
          toast.error(ToastMessages.general.error.genericError),
        );
      }
    } finally {
      setLoading(false);
    }
  }

  return { execute, loading };
}
